import React from 'react';
import { Link } from 'react-router-dom'; // Jika menggunakan React Router
import './ProductGrid.css';

const ProductGrid = ({ products }) => {
  return (
    <div className="product-grid" id='id-ebook-collection'>
      {products.map((product) => (
        <Link to={product.routePath} key={product.id} className="product-card">
          <img
            src={product.image}
            alt={product.name}
            className="product-image"
          />
        </Link>
      ))}
    </div>
  );
};

export default ProductGrid;